<template>
    <div>
        <table class="info_table" style="margin: 0;padding: 0; border-radius: 2px;">

            <tr>
                <th>{{ $t("vehicle.ManufactureNo") }}：</th>
                <td>{{ vehicleinfo.ManufactureID }}</td>
                <th>{{ $t("vehicle.VINCode") }}：</th>
                <td>{{ vehicleinfo.VINCode }}</td>
                <th>{{ $t("vehicle.DeviceNo") }}：</th>
                <td>{{ vehicleinfo.DeviceNo }}</td>
            </tr>

            <tr>
                <th>{{ $t("vehicle.carNo") }}：</th>
                <td>{{ vehicleinfo.CarNo }}</td>
                <th>{{ $t("vehicle.VelColor") }}：</th>
                <td>
                    <span v-if="vehicleinfo.VelColorID == 1"
                        style="display: inline-block; background: #2A7AFF;width: 12px;height: 12px;border-radius: 50%;">&nbsp;</span>
                    <span v-if="vehicleinfo.VelColorID == 2"
                        style="display: inline-block; background: #FBA31B;width: 12px;height: 12px;border-radius: 50%;">&nbsp;</span>
                    <span v-if="vehicleinfo.VelColorID == 3"
                        style="display: inline-block; background: #000;width: 12px;height: 12px;border-radius: 50%;">&nbsp;</span>
                    <span v-if="vehicleinfo.VelColorID == 4"
                        style="display: inline-block; background: #fff;width: 12px;height: 12px;border-radius: 50%;">&nbsp;</span>
                    <span v-if="vehicleinfo.VelColorID == 5"
                        style="display: inline-block; background: #07B477;width: 12px;height: 12px;border-radius: 50%;">&nbsp;</span>
                </td>
                <th>{{ $t("vehicle.VehicleModel") }}：</th>
                <td>{{ vehicleinfo.VehicleModel }}</td>
            </tr>

            <tr>
                <th>{{ $t("vehicle.DeviceType") }}：</th>
                <td>{{ vehicleinfo.DeviceType }}</td>
                <th>{{ $t("vehicle.VelType") }}：</th>
                <td>{{ vehicleinfo.VelType }}</td>
                <th>{{ $t("vehicle.StatusIdent") }}：</th>
                <td>
                    <span style="color: #07B477;" v-if="vehicleinfo.StateSignID == 1">{{ $t('state.effective') }}</span>
                    <span style="color: #FBA31B;" v-if="vehicleinfo.StateSignID == 0">{{ $t('state.invalid') }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ $t("vehicle.CanType") }}：</th>
                <td>
                    <span v-if="vehicleinfo.CTypeID == 0">{{ $t("public.unKnown") }}</span>
                    <span v-if="vehicleinfo.CTypeID == 1">妙益</span>
                    <span v-if="vehicleinfo.CTypeID == 2">威帝总线仪表\总线仪表升级版\简化版仪表</span>
                    <span v-if="vehicleinfo.CTypeID == 3">威帝全车总线</span>
                    <span v-if="vehicleinfo.CTypeID == 4">威帝2711新总线\汉纳森总线\欧科佳新总线</span>
                    <span v-if="vehicleinfo.CTypeID == 5">VDO总线</span>
                    <span v-if="vehicleinfo.CTypeID == 6">欧科佳</span>
                    <span v-if="vehicleinfo.CTypeID == 7">轻客KT</span>
                    <span v-if="vehicleinfo.CTypeID == 8">雪利曼</span>

                </td>
                <th>{{ $t("vehicle.OilType") }}：</th>
                <td>{{ showOilType(vehicleinfo.OilType) }}</td>
                <th>{{ $t("vehicle.Mobile") }}：</th>
                <td>{{ vehicleinfo.V_Mobile }}</td>
            </tr>
            <tr>
                <th>{{ $t("vehicle.TPMS") }}：</th>
                <td>
                    <span v-if="vehicleinfo.TPMS == 0">无</span>
                    <span v-if="vehicleinfo.TPMS == 1">海合达TPMS</span>
                    <span v-if="vehicleinfo.TPMS == 2">威帝TPMS</span>
                    <span v-if="vehicleinfo.TPMS == 3">上海保隆</span>

                </td>
                <th>{{ $t("vehicle.ProduceDate") }}：</th>
                <td>{{ vehicleinfo.ProduceDate ? vehicleinfo.ProduceDate.substr(0, 10) : "" }}</td>
                <th>{{ $t("vehicle.ComName") }}：</th>
                <td>{{ vehicleinfo.OwnerInfo }}</td>
            </tr>
            <tr>
                <th>{{ $t("vehicle.EngineBrand") }}：</th>
                <td>{{ showEngineBrand(vehicleinfo.EngineBrand) }}</td>
                <th>{{ $t("vehicle.EngineModel") }}：</th>
                <td>{{ vehicleinfo.EngineModel }}</td>
                <th></th>
                <td></td>
            </tr>
        </table>



    </div>
</template>
<script>

export default {
    props: {
        vid: {
            type: Number,
            default: 0
        }
    },
    watch: {
        vid() {
            if (this.vid != 0) {
                this.queryVehicleInfo();
            }
        }
    },
    data() {
        return {
            vehicleinfo: {},
            baseInfo: [
                { title: "出厂编号", value: "JP500278" },
                { title: "VIN码", value: "JP500278" },
                { title: "终端ID", value: "003612003583" },
                { title: "车牌号", value: "闽J05899D" },
                { title: "车牌颜色", value: "" },
                { title: "车辆型号", value: "XMQ6802AGBEVL11" },
                { title: "终端型号", value: "GK-110R7-G1A" },
                { title: "车辆类型", value: "未知" },
                { title: "状态标识", value: "有效", color: "#07B477" },
                { title: "CAN总线类型", value: "威帝2711新总线\汉纳森总线\欧科佳新总线" },
                { title: "燃油类型", value: "纯电动" },
                { title: "手机号", value: "13400682439" },
                { title: "TPMS通信", value: "--" },
                { title: "TPMS通信", value: "--" },
                { title: "总公司", value: "宁德市公共交通有限公司" },
                { title: "--", value: "--" }

            ],
            elecInfo: [
                { title: "电机厂家型号", value: "KLSTMAD150" },
                { title: "驱动电机额定功率", value: "90kw/h" },
                { title: "驱动电机峰值功率", value: "150kw/h" },
                { title: "驱动电机类型", value: "永磁同步电机" },
                { title: "驱动电机额定转速", value: "760rpm" },
                { title: "驱动电机额定转矩", value: "1140rpm" },
                { title: "驱动电机安装数量", value: "1个" },
                { title: "驱动电机布置型式/位置", value: "纵置/后置" },
                { title: "驱动电机冷却方式", value: "液冷" },
                { title: "电动汽车续驶里程", value: "335km" },
                { title: "--", value: "--" },
                { title: "--", value: "--" }
            ],
            batteryInfo: [
                { title: "电池类型", value: "磷酸铁锂蓄电池" },
                { title: "电池生产厂商", value: "浙江省宁德时代新能源科技股份有限公司" },
                { title: "电池容量", value: "130.89kw" },
                { title: "电池额定能量", value: "130.89kw" },
                { title: "电池额定电压", value: "483v" },
                { title: "储能装置种类", value: "磷酸铁锂蓄电池" },
                { title: "储能装置总成标称电压", value: "483v" },
                { title: "储能装置总储电量", value: "130.89kw" },
                { title: "--", value: "--" }
            ]
        }
    },
    methods: {
        showEngineBrand(EngineBrand) {
            if (EngineBrand == "其他类型") {
                return this.$t("public.otherType");
            }
            return EngineBrand;
        },
        showOilType(oilType) {
            if (oilType == "纯电动") {
                return this.$t("statistics.pureElectric");
            }
            return oilType;
        },
        queryVehicleInfo() {
            this.$api.QueryVehicleBaseInfo({
                vid: this.vid
            }).then(res => {
                if (res.code == 200) {
                    this.vehicleinfo = res.data;
                }
            });
        }
    },
    mounted() {

    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-col {
    display: flex;
}

.info_table {
    font-size: 12px;
    margin-bottom: 20px;
    border-spacing: 0;
    width: 100%;
    font-weight: normal;
    border-color: #C5D0E2;
    border-top: 1px solid #C5D0E2;
    border-right: 1px solid #C5D0E2;

    th {
        font-weight: normal;
        width: 130px;
        background: #E8F0FF;
        border-color: #C5D0E2;
        // border-top: 1px solid #C5D0E2;
        border-bottom: 1px solid #C5D0E2;
        border-right: 1px solid #C5D0E2;
        border-left: 1px solid #C5D0E2;


        text-align: right;

        &:first {
            border-left: 0;
        }
    }

    td {
        font-weight: normal;
        border-color: #C5D0E2;
        background: #fff;
        width: 120px;
        // border-top: 1px solid #C5D0E2;
        border-bottom: 1px solid #C5D0E2;
        padding: 25px 0px 25px 10px;

        text-align: left;
    }
}

.table {
    font-size: 12px;
    margin-bottom: 20px;
    border-radius: 2px;
    border: 1px solid #C5D0E2;
    border-bottom: 0;
    border-left: 0;
}

.title {
    background: #E8F0FF;
    border-bottom: 1px solid #C5D0E2;
    border-right: 1px solid #C5D0E2;
    border-left: 1px solid #C5D0E2;
    padding: 25px 10px 25px 0;
    flex: 1;
    text-align: right;

}

.value {
    background: #fff;
    border-bottom: 1px solid #C5D0E2;
    padding: 25px 0px 25px 10px;
    flex: 1;
    text-align: left;
}
</style>